import {
    Autocomplete as MuiAutocomplete,
    styled,
} from "@mui/material"
import { Form as FormikForm } from "formik"

import { L2RButton } from "../L2RButton"

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const Autocomplete = styled(MuiAutocomplete)(({ theme }) => ({
    margin: theme.spacing(2, 0),

    "& .MuiOutlinedInput-root, & .MuiFilledInput-root": {
        borderRadius: theme.spacing(3),
    },
}))

export const Option = styled("li")(() => ({
    display: "flex",
    alignItems: "center",
}))

export const OptionImage = styled("img")(({ theme }) => ({
    marginRight: theme.spacing(3),
    height: 28,
    width: 28,
    objectFit: "contain",
}))

export const ButtonsContainer = styled("div")(() => ({
    marginTop: "auto",
    display: "flex",
    justifyContent: "right",
}))

export const CancelButton = styled(L2RButton)(() => ({
    width: "fit-content",
}))

export const Form = styled(FormikForm)(() => ({
    flex: "1 1 auto",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
}))

export const TitleContainer = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(2),
}))

export const BackButtonPlaceholder = styled("div")({
    height: 40,
    width: 40,
})